module.exports = __webpack_public_path__ + "static/img/error.8113f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ErrorPage/images/error.png
// module id = QSwr
// module chunks = 169